export * from './activities';
export * from './timeline';

export * from './activities-timeline.component';
// The v2 timeline tree has no barrels, so this component is re-exported explicitly.
export { CrmActivityAssociationPopoverComponent } from './timeline-activities-v2/activities/system-activities/activity-card/association-popover.component';
